import { h, Fragment } from "preact";
import { useState, useContext, useEffect } from "preact/hooks";
import { makeStyles, useTheme } from "@mui/styles";

import { Box, Button, MobileStepper, Paper, Stack, Tooltip, Typography } from "@mui/material";
import { AppContext } from "../../AppContext";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
//import DeleteRealEstatePicturesDialog from "../PopUps/DeleteRealEstatePicturesDialog";
import UpdatePictureDialog from "../PopUps/UpdatePictureDialog";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 520,
    maxHeight: 640,
    flexGrow: 1,
  },
  header: {
    display: "flex",
    alignItems: "center",
    height: 50,
    paddingLeft: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
  },
  img_main: {
    //height: "66%",
    maxWidth: 500,
    maxHeight: 500,
    overflow: "hidden",
    display: "block",
    width: "100%",
  },
  img_main2: {
    //height: "66%",
    maxWidth: 500,
    maxHeight: 500,
    overflow: "hidden",
    display: "block",
    width: "100%",
  },
  img_200: {
    // height: "66%",
    maxWidth: 200,
    maxHeight: 200,
    overflow: "hidden",
    display: "block",
    //width: "100%",
  },
}));

export default function RealEstateCarousel({ deal_uid, pics, mode, upperStep, dim }) {
  //console.log("render RealEstateCarousel", upperStep, pics)
  const app = useContext(AppContext);
  const classes = useStyles();


  const [activeStep, setActiveStep] = useState(upperStep ? upperStep : 0);
  const maxSteps = pics.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  // const setUpperActiveStep = (idx) => {
  //   setActiveStep((prevActiveStep) => idx);
  // };

  useEffect(() => {

    //console.log("setUpperStep changed");
    if (upperStep !== undefined) {
      setActiveStep(upperStep)
    }


  }, [upperStep]);
  return (
    <div className={classes.root} style="border: 1px #dedede solid;">
      {false && pics && pics.length === 0 && <Typography>Vous n'avez pas encore uploadé de photos de votre bien</Typography>}

      {pics && pics.length > 0 && (
        <Stack spacing={1} display="flex" alignItems={"flex"} justifyContent="center">
          <Paper square elevation={0} className={classes.header}>
            <Box display={"flex"} justifyContent="space-between" alignItems={"center"} style="width: 100%;">
              <Box p={1}>
                <Box display={"flex"} justifyContent="flex-start" alignItems={"center"}>
                  <Box p={1}>
                    {mode === "RW" && (
                      <Tooltip title="Modifier la photo" placement="bottom" arrow>
                        <EditIcon

                          onClick={
                            () => {
                              app.refPopUp.current.handleChangeState(
                                { opened: true, type: "029", params: { pic: pics[activeStep] } }
                              )

                            }}
                        />
                      </Tooltip>
                    )}
                  </Box>
                  <Box p={1}>
                    {mode === "RW" && (
                      <Tooltip title="Supprimer la photo" placement="bottom" arrow>
                        <DeleteForeverIcon

                          onClick={
                            () => {
                              app.refPopUp.current.handleChangeState(
                                { opened: true, type: "026", params: { uid: pics[activeStep].uid } }
                              )

                            }}
                        />
                      </Tooltip>
                    )}
                  </Box>
                </Box>
              </Box>


              <Box p={1}>
                {pics[activeStep].cmt ? pics[activeStep].cmt : <Typography variant="body1"><em>Pas de commentaire</em></Typography>}</Box>
            </Box>

          </Paper>
          <Box display={"flex"} justifyContent="center" alignItems={"center"} >
            <Box p={1}>
              <img
                className={classes['img_' + dim]}
                style={"border: 1px solid gray; border-radius: 10px;"}
                src={`${THUMBS_URL}/${deal_uid}/${pics[activeStep].link}-${dim}.jpg`}
                alt={pics[activeStep].cmt}
              />
            </Box>
          </Box>
          <MobileStepper
            steps={maxSteps}
            position="static"
            variant="text"
            activeStep={activeStep}
            nextButton={
              <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                Suivant
                <KeyboardArrowRight />
              </Button>
            }
            backButton={
              <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                <KeyboardArrowLeft />
                Précédent
              </Button>
            }
          />
        </Stack>
      )}
    </div>
  );
}
